import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { AnchorLink, LinksContainer, OpenMenuBtn } from './styled';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useLocation, useNavigate } from 'react-router-dom';
var AnchorNavigation = function (_a) {
    var links = _a.links, _b = _a.defaultTitle, defaultTitle = _b === void 0 ? 'Sahl Tax Documents' : _b;
    var _c = useState(0), selected = _c[0], setSelected = _c[1];
    var _d = useState(false), isMenuOpen = _d[0], setIsMenuOpen = _d[1];
    var navigate = useNavigate();
    var location = useLocation();
    useEffect(function () {
        var currentIndex = -1;
        links.forEach(function (link, index) {
            var isMatch = location.pathname === link.path
                || location.pathname.startsWith("".concat(link.path, "/"));
            if (isMatch && (currentIndex === -1 || link.path.length > links[currentIndex].path.length)) {
                currentIndex = index;
            }
        });
        if (currentIndex !== -1) {
            setSelected(currentIndex);
            document.title = links[currentIndex].label;
        }
        else {
            if (location.pathname === '/') {
                document.title = 'Welcome';
            }
            else {
                document.title = defaultTitle;
            }
        }
    }, [location, links, defaultTitle]);
    var onItemClick = useCallback(function (_a) {
        var index = _a.index, path = _a.path;
        setSelected(index);
        navigate(path);
    }, []);
    return (_jsxs(LinksContainer, { "$isMenuOpen": isMenuOpen, children: [_jsx(OpenMenuBtn, { onClick: function () { return setIsMenuOpen(function (prev) { return !prev; }); }, children: isMenuOpen ? _jsx(ArrowBackIosNewIcon, {}) : _jsx(ArrowForwardIosIcon, {}) }), links.map(function (_a, index) {
                var label = _a.label, path = _a.path;
                return (_jsx(AnchorLink, { onClick: function () {
                        onItemClick({ path: path, index: index });
                        setIsMenuOpen(function (prev) { return !prev; });
                    }, "$active": index === selected, children: label }, path));
            })] }));
};
export default AnchorNavigation;
